import React from 'react';
import style from './AccountTypeForm.module.scss';
import ChoiceCard from 'components/Auth/Register/ChoiceCard/ChoiceCard';
import IndividualIcon from 'components/common/icons/IndividualIcon';
import CompanyIcon from 'components/common/icons/CompanyIcon';
import {COMPANY_TYPES} from 'components/common/Form/AccountTypeSelect/const';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';

const AccountTypeForm = ({onChange, onNextStep, isModal}) => {
    const {t} = useTranslation();
    return (
        <div className={cn(style.accountType, {[style.modal]: isModal})}>
            <ChoiceCard
                icon={<IndividualIcon />}
                title={COMPANY_TYPES[1].label}
                onClick={role => {
                    onChange('accountType', role, onNextStep);
                }}
                role={COMPANY_TYPES[1].value}
                text={t('welcome:text.individualText')}
            />
            <ChoiceCard
                icon={<CompanyIcon />}
                title={COMPANY_TYPES[0].label}
                onClick={role => {
                    onChange('accountType', role, onNextStep);
                }}
                role={COMPANY_TYPES[0].value}
                text={t('welcome:text.companyText')}
            />
        </div>
    );
};

export default AccountTypeForm;
